import { AtemStatusEnum } from "@modules/orders/dtos/ICreateOrderDataDTO";
import { IOrders } from "@pages/User/NewRequest/Model";

import {
  capitalizeFirstLetterFullString,
  formatCurrencyPriceWithTwoDigit,
  formatDateWithoutHours,
  formatAmount,
} from "@utils/index";

export const formatterOrder = (order: IOrders) => {
  const {
    numberOrder = "Error",
    subsidiary = "Error",
    deliveryDate = "",
    product: { description = "", price = 0, quantity = 0, deadlinePayment = 0 },
  } = order;

  const statusKey =
    order.status === "error" ? "error" : order?.atemStatus || undefined;

  return {
    numberOrder,
    subsidiary: capitalizeFirstLetterFullString(subsidiary),
    deliveryDate: formatDateWithoutHours(deliveryDate) || "Error",
    product: description,
    quantity: formatAmount(quantity),
    price: formatCurrencyPriceWithTwoDigit(calcTotal(price, quantity)),
    paymentTerm: renderPaymentTerm(deadlinePayment),
    atemStatus: customRenderStatus(statusKey),
  };
};

const calcTotal = (price?: number, quantity?: number) =>
  price && quantity ? price * quantity : 0;

const pluralize = (n: number, singular: string, plural: string) =>
  `${n} ${n === 1 ? singular : plural}`;

const renderPaymentTerm = (deadlinePayment?: number) =>
  deadlinePayment ? pluralize(deadlinePayment, "dia", "dias") : "À vista";

export const customRenderStatus = (
  status: string | undefined,
  message?: string
): string => {
  switch (status) {
    case AtemStatusEnum.LIB:
      return "Liberado";
    case AtemStatusEnum.BL:
      return "Bloqueado";
    case AtemStatusEnum.ERROR:
      return `Erro: Não foi possível criar a ordem de venda`;
    default:
      return "-";
  }
};
